export const account_1 = {
	account_1_1: require('@/assets/images/account/1/1.png'),
	account_1_2: require('@/assets/images/account/1/2.png'),
	account_1_3: require('@/assets/images/account/1/3.png'),
	account_1_4: require('@/assets/images/account/1/4.png'),
	account_1_5: require('@/assets/images/account/1/5.png'),
};

export const account_2 = {
	account_2_1: require('@/assets/images/account/2/1.png'),
	account_2_2: require('@/assets/images/account/2/2.png'),
	account_2_3: require('@/assets/images/account/2/3.png'),
	account_2_4: require('@/assets/images/account/2/4.png'),
	account_2_5: require('@/assets/images/account/2/5.png'),
	account_2_6: require('@/assets/images/account/2/6.png'),
};

export const account_3 = {
	account_3_1: require('@/assets/images/account/3/1.png'),
	account_3_2: require('@/assets/images/account/3/2.png'),
	account_3_3: require('@/assets/images/account/3/3.png'),
	account_3_4: require('@/assets/images/account/3/4.png'),
};

export const account_4 = {
	account_4_1: require('@/assets/images/account/4/1.png'),
	account_4_2: require('@/assets/images/account/4/2.png'),
	account_4_3: require('@/assets/images/account/4/3.png'),
	account_4_4: require('@/assets/images/account/4/4.png'),
	account_4_5: require('@/assets/images/account/4/5.png'),
	account_4_6: require('@/assets/images/account/4/6.png'),
	account_4_7: require('@/assets/images/account/4/7.png'),
	account_4_8: require('@/assets/images/account/4/8.png'),
	account_4_9: require('@/assets/images/account/4/9.png'),
};

export const account_5 = {
	account_5_1: require('@/assets/images/account/5/1.png'),
	account_5_2: require('@/assets/images/account/5/2.png'),
	account_5_3: require('@/assets/images/account/5/3.png'),
	account_5_4: require('@/assets/images/account/5/4.png'),
	account_5_5: require('@/assets/images/account/5/5.png'),
	account_5_6: require('@/assets/images/account/5/6.png'),
	account_5_7: require('@/assets/images/account/5/7.png'),
	account_5_8: require('@/assets/images/account/5/8.png'),
};
